import { RefObject, useEffect } from 'react';
import { MapRef } from 'react-map-gl';

import { parseLatLng } from '../utils';

type MapCoordinatePreviewParams = {
  mapRef: RefObject<MapRef>;
  mapLoaded: boolean;
  lat: string;
  lng: string;
  active: boolean;
};

export const useMapCoordinatePreview = ({ mapRef, mapLoaded, lat, lng, active }: MapCoordinatePreviewParams) => {
  const coords = parseLatLng(lat, lng);
  const hasValidPreview = coords !== null;

  useEffect(() => {
    if (!mapLoaded || !hasValidPreview || !active || !mapRef.current || !coords) return;
    mapRef.current.flyTo({ center: [Number(coords.lng), Number(coords.lat)], zoom: 14, duration: 600 });
  }, [mapLoaded, hasValidPreview, coords, active, mapRef]);

  return { hasValidPreview, previewLat: Number(coords?.lat ?? 0), previewLng: Number(coords?.lng ?? 0) };
};
